import React from "react";
import LoadingSpinner from "../LoadingSpinner";
import { fetchReCaptchaToken } from "../Guard";
import Types from "prop-types";

export const CSRF_QUERY_PARAM = "csrf";
export const CSRF_SESSION_STORAGE_FIELD = "idp." + CSRF_QUERY_PARAM;

export default class RedirectToLogin extends React.Component {
  state = { recaptcha: "" };

  constructor(props) {
    super(props);
    this.form = React.createRef();
  }

  componentDidMount() {
    fetchReCaptchaToken("signup_redirect_to_login").then((recaptcha) => {
      this.setState({ recaptcha });
      this.form.submit();
    });
  }

  render() {
    return (
      <div>
        <LoadingSpinner />
        <form
          action={`${process.env.REACT_APP_IDENTITY_HOST}/login`}
          method="post"
          ref={(ref) => {
            this.form = ref;
          }}
        >
          <input
            name="g-recaptcha-response"
            type="hidden"
            value={this.state.recaptcha}
          />
          <input
            name={this.props.fieldName}
            type="hidden"
            value={this.props.value}
          />
          <input name="_csrf" hidden={true} value={this.props.csrf} />
        </form>
      </div>
    );
  }
}
RedirectToLogin.propTypes = {
  fieldName: Types.string.isRequired,
  value: Types.string.isRequired,
  csrf: Types.string.isRequired,
};
